import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHeader = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.115 11.6H3.023V16H.685V5.262h2.338v4.276h4.092V5.262h2.339V16H7.115v-4.4Zm4.58-6.985h2.276v4.677h.093c.143-.42.395-.784.753-1.092.36-.308.857-.462 1.493-.462.83 0 1.456.277 1.877.831.43.554.646 1.344.646 2.37V16h-2.277v-4.877c0-.523-.082-.908-.246-1.154-.164-.256-.457-.384-.877-.384-.185 0-.364.025-.539.077a1.34 1.34 0 0 0-.477.215c-.133.102-.24.23-.323.384a1.006 1.006 0 0 0-.123.508V16h-2.277V4.615Z",
			fill: "#4D4540"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h20v20H0z"
		})
	}) })]
});
export default SvgIconHeader;
